import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ToastActionButton, ToastActionsWrapper, ToastText } from './ToastStyles';

const RefreshPageToast = ({ message, events }) => {
  const { t } = useTranslation();

  const handleRefresh = useCallback(() => {
    const { onRefresh } = events;
    onRefresh && onRefresh();
    window.location.reload();
  }, [events]);

  const handleDismiss = useCallback(() => {
    const { onDismiss } = events;
    onDismiss && onDismiss();
  }, [events]);

  return (
    <div>
      <ToastText>{message}</ToastText>
      <ToastActionsWrapper>
        <ToastActionButton id='RefreshPageToast_RefreshButton' onClick={handleRefresh}>
          {t('Refresh')}
        </ToastActionButton>
        <ToastActionButton id='RefreshPageToast_DismissButton' onClick={handleDismiss}>
          {t('Dismiss')}
        </ToastActionButton>
      </ToastActionsWrapper>
    </div>
  );
};

RefreshPageToast.defaultProps = {
  events: {
    onRefresh: () => {},
    onDismiss: () => {}
  }
};

RefreshPageToast.propTypes = {
  message: PropTypes.string,
  events: PropTypes.shape({
    onRefresh: PropTypes.func,
    onDismiss: PropTypes.func
  })
};

export default RefreshPageToast;
